import styled, { css } from 'styled-components/macro'

import Wallpaper from 'components/radio/assets/wallpaper.png'
import Furniture from 'components/radio/assets/furniture.png'
import { mq } from 'styles/mq'

export const View = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${mq.smallOnly} {
    background: url(${Wallpaper}) 50% 0 / cover no-repeat;
  }
  ${mq.medium} {
    background: url(${Wallpaper}) 50% 0 / cover no-repeat;
  }
`

export const TVContainer = styled.div`
  --base-unit: 100vmin;
  --knob-size: calc(var(--base-unit) * 0.108);
  --image-native-width: 1165;
  --image-native-height: 907;
  --radio-furniture-overlay: 0.1;

  position: relative;
  width: var(--base-unit);
  aspect-ratio: var(--image-native-width) / var(--image-native-height);

  ${mq.smallOnly} {
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: calc(100% - 6vw);
      left: 50%;
      width: 100vw;
      height: calc(
            (50vh - (50vw * (var(--image-native-height) / var(--image-native-width)))) + 6vw
      );
      transform: translateX(-50%);
      background: url(${Furniture}) center top/cover no-repeat;
    }
  }
  ${mq.medium} {
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: calc(
        100% -
          (
            var(--base-unit) * var(--image-native-height) /
              var(--image-native-width) * var(--radio-furniture-overlay)
          )
      );
      left: 50%;
      width: 100vw;
      height: calc(
        (
            50vh -
              (
                (var(--base-unit) / 2) *
                  (var(--image-native-height) / var(--image-native-width))
              )
          ) +
          (
            var(--base-unit) * var(--image-native-height) /
              var(--image-native-width) * var(--radio-furniture-overlay)
          )
      );
      transform: translateX(-50%);
      background: url(${Furniture}) center top/cover no-repeat;
    }
  }

  audio,
  video {
    position: absolute;
  }
`

export const StyledVideo = styled.video<{ $stretch?: boolean, isOpen?: boolean }>`
  display: block;
  top: 16%;
  left: 10%;
  width: 62%;
  height: 63%;
  background-color: black;

  ${props =>
    props.$stretch &&
    css`
      object-fit: cover;
    `}
    
  ${props => props.isOpen && css`
    position: absolute;
    z-index: 100;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `}
`

export const DebugLine = styled.p`
  margin: 0.5rem 0;
  font-size: 1.6rem;
  text-transform: uppercase;
  font-weight: bold;
`

export const DebugValue = styled.span`
  display: inline-block;
  padding: 0 0.3em;
  border-radius: 3px;
  background-color: #ffdc75;
`

export const StyledPopupControl = styled.div<{ isOpen: boolean }>`
  cursor: pointer;
  display: block;
  position: absolute;
  left: 10%;
  top: 16%;
  width: 61%;
  height: 62%;
  z-index: 99;
    ${props => props.isOpen && css`
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.5);
  `}
`
